import React from "react"
import { Loader2 } from "lucide-react"
import { cn } from "../../../../lib"
const Button = ({
  color = "second",
  size = "md",
  rounded = "md",
  className,
  type = "button",
  children = "Button",
  isLoading = false,
  disabled,
  ...props
}) => {
  const roundeds = {
    sm: "rounded-sm",
    md: "rounded-md",
    lg: "rounded-lg",
    full: "rounded-full",
  }

  const sizes = {
    sm: "px-3 py-1.5 text-sm",
    md: "px-4 py-2 text-base",
    lg: "px-5 py-[12px] text-lg",
  }

  const colors = {
    one: "bg-app-base text-white hover:bg-app-base-strong",
    second: "bg-app-base-strong text-white hover:bg-app-base",
    third: "bg-white text-app-content hover:bg-app-content/5",
  }

  return (
    <button
      type={type}
      disabled={isLoading || disabled}
      className={cn(
        "relative inline-flex items-center justify-center gap-2 cursor-pointer transition-all duration-300 disabled:opacity-60 disabled:cursor-not-allowed",
        roundeds[rounded],
        sizes[size],
        colors[color],
        className
      )}
      {...props}
    >
      {isLoading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  )
}

export default Button
